<style lang="scss" src="./About.scss"></style>

<template>
    <div class="app-about">
        <div class="wrapper l-wrapper">
            <div class="l-half">
                <h1 class="title title--primary about-title">
                    <span>{{ t('about') }}</span>
                    <span v-if="this.$translate.locale.me">{{ t('me') }}</span>             
                </h1>

                <about-item v-for="(value) of about" :about_data="value[$translate.lang]" v-bind:key="value.title"></about-item>
            </div>

            <div class="l-half">
                <div ref="portraitContainer" class="portrait-container">
                    <img ref="portrait" class="about-image" src="/static/images/portrait-3.jpg" alt="Julien Barreira">
                </div>
                <div ref="portraitContainer" class="portrait-container">
                    <img ref="portrait" class="about-image" src="/static/images/portrait-2.jpg" alt="Julien Barreira">
                </div>
                <div ref="portraitContainer" class="portrait-container">
                    <img ref="portrait" class="about-image" src="/static/images/portrait-1.jpg" alt="Julien Barreira">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import about from '../../data/about.json'
    import aboutItem from '../AboutItem/AboutItem.vue'
    import AssetsLoader from 'assets-loader'
    import LoaderMixin from '../Loader/LoaderMixin.js'

    export default {
        
        mixins: [LoaderMixin],

        components: {
            'about-item': aboutItem
        },
        
        data() {
            return {
                about,
                app: this.$parent
            }
        },
        
        metaInfo () {
            return {
                title: 'Julien Barreira',
                titleTemplate: '%s - ' + this.$translate.locale.about
            }
        },
        
        updated() {
            if (!this.app.firstLoad) {
                this.app.smoothScroll.onResize();
            }
        },
        
        locales: {
            en: {
                'about': 'About',
                'me': 'me'
            },
            fr: {
                'about': 'À propos'
            }
        },
                
        beforeRouteLeave (to, from, next) {        
            next(false)
            var self = this

            // on initialise le loader                
            let assetsLoader = AssetsLoader()

            if (to.name !== 'about_component') {
                
                window.removeEventListener('resize', this.resizeCanvas)

                this.loadContent(self, assetsLoader, to, next, this.app)

                // on reset le scroll une fois le loader enclenché
                setTimeout(function () {
                    if (!self.app.isMobile) {                        
                        self.app.resetScroll()
                        self.app.smoothScroll.applyTransform(self.app.$refs.scrollZone, 0)
                    }

                }, 700)

            } else {
                next()
            }

        }
        
    }

</script>


// WEBPACK FOOTER //
// src/components/About/About.vue